'use strict';

angular.module('shiftTraderApp')
  .controller('TradeCtrl', function ($scope, ShiftTradeResponsesResource, WorkPeriods, trade, me, org, $filter,
                                     $rootScope, flash, SAErrorHandler, TimeService, Users, UserPermissionsService) {
    $scope.me = me;
    $scope.trade = trade.$initialize();
    $scope.org = org;
    $scope.form = {
      message: ''
    };
    if ($scope.trade.$isGiveaway()) {
      $rootScope.$broadcast('setTopNavTitle', 'Giveaway');
    } else {
      $rootScope.$broadcast('setTopNavTitle', 'Trade');
    }

    $scope.tradeAlerts = [];


    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    function processRawPermissions() {
      $scope.state.derivedPermissions = {
        canApproveTrade: $scope.state.rawPermissions['trades.approve']
      };
    }

    UserPermissionsService.getCanDict(['trades.approve'], $scope.trade.organization_id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });


    $scope.trade.work_period.position._department_name = (function() {
      var deptId = $scope.trade.work_period.position.department_id;
      if (!_.isNull(deptId)) {
        var dept = _.find($scope.org.departments, {id: deptId});
        return _.isUndefined(dept) ? '' : dept.name;
      } else {
        return '';
      }
    }());

    if (!$scope.trade.$isGiveaway()) {
      $scope.trade.trade_work_period.position._department_name = (function() {
        var deptId = $scope.trade.trade_work_period.position.department_id;
        if (!_.isNull(deptId)) {
          var dept = _.find($scope.org.departments, {id: deptId});
          return _.isUndefined(dept) ? '' : dept.name;
        } else {
          return '';
        }
      }());
    }


    WorkPeriods.getAll({
      user_id: $scope.me.id,
      start_time: moment($scope.trade.work_period.start_time).subtract(1,'days').toISOString(),
      end_time: moment($scope.trade.work_period.end_time).add(1,'days').toISOString()
    })
      .then(function(myWorkPeriods) {
        $scope.myWorkPeriods = myWorkPeriods;
        _.all(_.filter($scope.myWorkPeriods, function(wp) {
          return wp.$isAssigned() && wp.user.id === $scope.me.id && wp.$isPublished();
        }), function(w) {
          var overlap = w.range_twix.overlaps($scope.trade.work_period.range_twix) &&
            Math.abs(w.range_twix.intersection($scope.trade.work_period.range_twix).length('minutes')) > 0;
          if (overlap) {
            $scope.overlapPreventingGiveaway = {
              workPeriod: w,
              intersection: w.range_twix.intersection($scope.trade.work_period.range_twix),
              intInMin: Math.abs(w.range_twix.intersection($scope.trade.work_period.range_twix).length('minutes'))
            };
          }
          return !overlap;
        });
        $scope.giveawayOverlapHasBeenCalculated = true;

      }, function() {
        console.log('had a problem loading my work periods');
      });


    var abbreviatedName = $filter('abbreviatedName');
    $scope.tradeHeaderMessage = (function() {
      if (!$scope.trade.$isGiveaway()) {
        // trade is not a giveaway
        if ($scope.trade.$isInitiator($scope.me)) {
          return 'Your Trade With ' + abbreviatedName($scope.trade.trade_user.name);
        } else if ($scope.trade.trade_user.id === $scope.me.id) {
          return abbreviatedName($scope.trade.user.name) + '\'s Trade With You';
        } else {
          // user who is not involved in the trade is looking at it
          return abbreviatedName($scope.trade.user.name) + '\'s Trade With ' + abbreviatedName($scope.trade.trade_user.name);
        }
      } else {
        //trade is a giveaway
        if ($scope.trade.$isInitiator($scope.me)) {
          if ($scope.trade.$isAccepted()) {
            // me is the initiator of the giveaway and it has been accepted
            return 'Your Giveaway To ' + abbreviatedName($scope.trade.$acceptingUser().name);
          } else {
            // me is the initiator of the giveaway and it has NOT been accepted
            return 'Your Giveaway';
          }
        } else if (_.any($scope.trade.shift_trade_responses, function(resp) {
          return resp.user.id === $scope.me.id && resp.acceptance_code === 10;
        })) {
          // me is the taker of the giveaway (accepted)
          return 'Picking Up ' + abbreviatedName($scope.trade.user.name) + '\'s Shift';
        } else {
          //me is someone outside of the giver/taker relationship of the giveaway
          return abbreviatedName($scope.trade.user.name) + '\'s Giveaway';
        }
      }
    }());

    $scope.inactiveTrade = $scope.trade.$isInThePast() || _.any($scope.trade.shift_trade_responses, function (response) {
      if ($scope.trade.$isGiveaway()) {
        return _.contains([20,21], response.acceptance_code) || (response.acceptance_code === 11 && trade.$isRejectedBy($scope.me));
      } else {
        return _.contains([11, 20, 21], response.acceptance_code);
      }
    });

    $scope.responseSent = _.any($scope.trade.shift_trade_responses, function(response) {
      return me.id === response.user.id && _.contains([10,11], response.acceptance_code);
    });

    $scope.acceptTrade = function () {
      var response = new ShiftTradeResponsesResource();

      response.user_id = me.id;
      if (!$scope.trade.$isGiveaway()) {
        response.work_period_id = $scope.trade.trade_work_period.id;
      }
      response.shift_trade_id = $scope.trade.id;
      response.acceptance_code = 'ACCEPTED';

      response.$save(function (response) {
        $scope.trade.shift_trade_responses.push(response);
        $scope.responseSent = true;
        flash.success = 'Trade accepted!';
      }, function(response) {
        console.log('acceptTrade error');
        console.log(response);
        SAErrorHandler.processError(response);
      });
    };

    $scope.declineTrade = function () {
      var response = new ShiftTradeResponsesResource();

      response.user_id = me.id;
      if (!trade.$isGiveaway()) {
        response.work_period_id = $scope.trade.trade_work_period.id;
      }
      response.shift_trade_id = $scope.trade.id;
      response.acceptance_code = 'REJECTED';

      response.$save(function (response) {
        $scope.trade.shift_trade_responses.push(response);
        $scope.inactiveTrade = true;
        $scope.responseSent = true;
        if ($scope.trade.user.id === response.user.id) {
          flash.success = 'Trade cancelled!';
        } else {
          flash.success = 'Trade declined!';
        }
      }, function(response) {
        console.log('acceptTrade error');
        console.log(response);
        SAErrorHandler.processError(response);
      });
    };

    $scope.approveTrade = function () {
      var response = new ShiftTradeResponsesResource();

      response.user_id = me.id;
      if (!$scope.trade.$isGiveaway()) {
        response.work_period_id = $scope.trade.trade_work_period.id;
      }
      response.shift_trade_id = $scope.trade.id;
      response.acceptance_code = 'APPROVED';

      response.shift_trade_response_id = _($scope.trade.shift_trade_responses).where({acceptance_code: 10}).pluck('id').first();

      response.$save(function (response) {
        $scope.trade.shift_trade_responses.push(response);
        $scope.responseSent = true;
        $scope.inactiveTrade = true;
        flash.success = 'Trade approved!';
      }, function(response) {
        console.log('acceptTrade error');
        console.log(response);
        SAErrorHandler.processError(response);
      });
    };

    $scope.disapproveTrade = function () {
      var response = new ShiftTradeResponsesResource();

      response.user_id = me.id;
      if (!$scope.trade.$isGiveaway()) {
        response.work_period_id = $scope.trade.trade_work_period.id;
      }
      response.shift_trade_id = $scope.trade.id;
      response.acceptance_code = 'DISAPPROVED';

      if (!$scope.trade.$isGiveaway() && _.where($scope.trade.shift_trade_responses, {acceptance_code: 10}).length > 0) {
        response.shift_trade_response_id = _($scope.trade.shift_trade_responses).where({acceptance_code: 10}).pluck('id').first();
      } else {
        response.shift_trade_response_id = null;
      }

      response.$save(function (response) {
        $scope.trade.shift_trade_responses.push(response);
        $scope.responseSent = true;
        $scope.inactiveTrade = true;
        flash.success = 'Trade disapproved.';
      }, function(response) {
        console.log('disapproveTrade error');
        console.log(response);
        SAErrorHandler.processError(response);
      });
    };

    $scope.sendMessage = function () {
      var response = new ShiftTradeResponsesResource();

      response.user_id = me.id;
      response.shift_trade_id = $scope.trade.id;
      response.message = $scope.form.message;
      response.acceptance_code = 'MESSAGE';

      response.$save(function (response) {
        $scope.trade.shift_trade_responses.push(response);
        $scope.form.message = '';
        flash.success = 'Message sent.';
      }, function(response) {
        console.log('acceptTrade error');
        console.log(response);
        SAErrorHandler.processError(response);
      });
    };







      $scope.initiatorUp = _.find($scope.trade.user.users_positions, {position_id: $scope.trade.work_period.position_id});
      $scope.analysis = {};

      var calcAffectedTimeWindow = function(shiftedByDayHourStart) {
        var allWeeks = [];

        if (_.isUndefined(shiftedByDayHourStart)) {
          //get the weeks associated with trade.work_period start and end
          //get the weeks associated with trade.trade_work_period start and end
          allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.work_period.start_time));
          allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.work_period.end_time));

          if (!$scope.trade.$isGiveaway()) {
            allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.trade_work_period.start_time));
            allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.trade_work_period.end_time));
          }
        } else {
          //get the weeks associated with trade.work_period start and end
          //get the weeks associated with trade.trade_work_period start and end
          allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.work_period.start_time, 0, 0, true));
          allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.work_period.end_time, 0, 0, true));

          if (!$scope.trade.$isGiveaway()) {
            allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.trade_work_period.start_time, 0, 0, true));
            allWeeks.push(TimeService.getWeekTwixFromMoment($scope.trade.trade_work_period.end_time, 0, 0, true));
          }
        }


        var allWeeksUnique = _.unique(allWeeks, function(x) {
          return x.format();
        });
        console.log(allWeeksUnique);

        //return the earlier start date of all twixes and the latest end date of all twixes
        return {
          fullSpan: _.reduce(allWeeksUnique, function(accum, x) {
            return accum.union(x);
          }, allWeeksUnique[0]),
          weeks: _.sortBy(allWeeksUnique, function(twix) {
            return twix.start.unix();
          })
        };
      };

      $scope.affectedTimeWindow = calcAffectedTimeWindow();
      $scope.workPeriodDatesByWeek = _.map($scope.affectedTimeWindow.weeks, function(weekTwix) {
        return _.map(_.range(7), function(dayNum) {
          return moment(weekTwix.start).add(dayNum, 'days');
        });
      });

      $scope.workPeriodDatesByWeekShifted = _.map(calcAffectedTimeWindow(true), function(weekTwix) {
        return _.map(_.range(7), function(dayNum) {
          return moment(weekTwix.start).add(dayNum, 'days');
        });
      });

      $scope.tradeHasReceiver = !$scope.trade.$isGiveaway() || ($scope.trade.$isGiveaway() && $scope.trade.$isAccepted());




      $scope.analysis.skillLevel = {
        workPeriod: {},
        tradeWorkPeriod: {}
      };
      // analyze each employees "star" level in the subsequent users_position entry
      var initiatorUps = {
        workPeriodPos: _.find($scope.trade.user.users_positions, {position_id: $scope.trade.work_period.position_id}),
        tradeWorkPeriodPos: !$scope.trade.$isGiveaway() ?
            _.find($scope.trade.user.users_positions, {position_id: $scope.trade.trade_work_period.position_id})
            : undefined
      };


      var calculateLevelsAnalysis = function(giveawayReceivingUser) {
        var workPeriodRankingDiff;
        if (!$scope.trade.$isGiveaway()) {
          var receiverUps = {
            workPeriodPos: _.find($scope.trade.trade_user.users_positions, {position_id: $scope.trade.work_period.position_id}),
            tradeWorkPeriodPos: _.find($scope.trade.trade_user.users_positions, {position_id: $scope.trade.trade_work_period.position_id})
          };

          $scope.analysis.skillLevel.isSamePosition = ($scope.trade.work_period.position_id === $scope.trade.trade_work_period.position_id);

          if (receiverUps.workPeriodPos && receiverUps.tradeWorkPeriodPos) {
            workPeriodRankingDiff = receiverUps.tradeWorkPeriodPos.ranking - initiatorUps.workPeriodPos.ranking;
            var tradeWorkPeriodRankingDiff = initiatorUps.tradeWorkPeriodPos.ranking - receiverUps.workPeriodPos.ranking;

            if (receiverUps.tradeWorkPeriodPos.ranking !== 0 && initiatorUps.workPeriodPos.ranking !== 0) {
              $scope.analysis.skillLevel.workPeriod.message = (function() {
                if (workPeriodRankingDiff > 0) {
                  return '+' + workPeriodRankingDiff;
                } else if (workPeriodRankingDiff === 0) {
                  return 'Even (' + initiatorUps.workPeriodPos.ranking + ')';
                } else {
                  return workPeriodRankingDiff;
                }
              }());
            } else {
              $scope.analysis.skillLevel.workPeriod.message = 'Not ranked';
            }

            if (initiatorUps.tradeWorkPeriodPos.ranking !== 0 && receiverUps.workPeriodPos.ranking !== 0) {
              $scope.analysis.skillLevel.tradeWorkPeriod.message = (function() {
                if (tradeWorkPeriodRankingDiff > 0) {
                  return '+' + tradeWorkPeriodRankingDiff;
                } else if (tradeWorkPeriodRankingDiff === 0) {
                  return 'Even (' + initiatorUps.tradeWorkPeriodPos.ranking + ')';
                } else {
                  return tradeWorkPeriodRankingDiff;
                }
              }());
            } else {
              $scope.analysis.skillLevel.tradeWorkPeriod.message = 'Not ranked';
            }
          }
        } else {
          var initiatorUp = _.find($scope.trade.user.users_positions, {position_id: $scope.trade.work_period.position_id});
          var receiverUp = _.find(giveawayReceivingUser.users_positions, {position_id: $scope.trade.work_period.position_id});

          if (initiatorUp && receiverUp) {
            workPeriodRankingDiff = receiverUp.ranking - initiatorUp.ranking;

            if (receiverUp.ranking > 0 && initiatorUp.ranking > 0) {
              $scope.analysis.skillLevel.workPeriod.message = (function() {
                if (workPeriodRankingDiff > 0) {
                  return '+' + workPeriodRankingDiff;
                } else if (workPeriodRankingDiff === 0) {
                  return 'Even (' + initiatorUp.ranking + ')';
                } else {
                  return workPeriodRankingDiff;
                }
              }());
            } else if (receiverUp.ranking === 0 || initiatorUp.ranking === 0) {
              $scope.analysis.skillLevel.workPeriod.message = 'Not ranked';
            } else {
              $scope.analysis.skillLevel.workPeriod.message = 'Waiting for taker...';
            }
          }

        }
      };

    UserPermissionsService.can('users_positions.view_ranking', $scope.trade.organization_id)
      .then(function(result) {
        if (result) {
          if ($scope.trade.$isGiveaway()) {
            if ($scope.tradeHasReceiver) {
              Users.getById($scope.trade.$acceptingUser().id).
                then(function(acceptingUser) {
                  calculateLevelsAnalysis(acceptingUser);
                });
            } // if there is no receiver, do nothing
          } else {
            calculateLevelsAnalysis();
          }

        }
      });



      var initiatorData = {
        user_id: $scope.trade.user.id,
        organization_id: $scope.trade.organization_id,
        start_time: $scope.affectedTimeWindow.fullSpan.start.toISOString(),
        end_time: $scope.affectedTimeWindow.fullSpan.end.toISOString()
      };

      WorkPeriods.getAll(initiatorData).
          then(function(data) {
            $scope.initiatorWorkPeriods = data;
            $scope.analysis.initiator = {};
            var concatData;
            if ($scope.trade.$isApproved()) {
              concatData = [$scope.trade.work_period];
            } else {
              concatData = ($scope.tradeHasReceiver && !$scope.trade.$isGiveaway()) ? [$scope.trade.trade_work_period] : [];
            }

            $scope.initiatorWorkPeriodsByWeekAndDay = _.map($scope.workPeriodDatesByWeek, function(weekOfDates, idWeek) {
              var temp = {
                days: _.map(weekOfDates, function(dt, idDay) {
                  var theTwix = dt.twix(moment(dt).add(1, 'days'));
                  var theTwixShifted = $scope.workPeriodDatesByWeekShifted[idWeek][idDay].twix(moment($scope.workPeriodDatesByWeekShifted[idWeek][idDay]).add(1, 'days'));

                  var ret = {
                    dayStartDate: dt,
                    workPeriods: _.sortBy(_.where(_.union($scope.initiatorWorkPeriods, concatData), function(wp) {
                      //figure out what classes this wp should have
                      wp._cssClasses = {
                        // in the case of a giveaway, need to block the second term here with !$scope.trade.$isGiveaway()
                        red: wp.id === $scope.trade.work_period.id || _.contains($scope.trade.work_period.related_work_period_ids, wp.id),
                        green: !$scope.trade.$isGiveaway() && (wp.id === $scope.trade.trade_work_period.id || _.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id)),
                        continues: wp._intoNextDay
                      };

                      // where function to only get wp's where start_time is contained inside dt->dt+1d

                      //use theTwix here because we want the shifts to be on the correct calendar day visually
                      return theTwix.contains(wp.start_time);
                    }), '_startTimeUnix'),
                    hoursWithoutTrade: _.reduce(_.map(_.union($scope.initiatorWorkPeriods, concatData), function(wp) {
                      // in the case of an approved trade, need to use concatData (trade.work_period) as counted hours
                      //     AND reject wp.id in trade.trade_work_period.related_work_period_ids

                      // in the case of an unapproved trade, need to reject concatData (trade.trade_work_period.id)
                      // if the trade $isGiveaway() then this logic MUST be short-circuited before it hits the .trade_work_period properties
                      //   it is safe to process concatData when it is a giveaway because concatData = [] above
                      if ( $scope.trade.$isGiveaway() ||
                          ($scope.trade.$isApproved() && !_.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id)) ||
                          (!$scope.trade.$isApproved() && wp.id !== $scope.trade.trade_work_period.id)) {
                        if (wp.range_twix.overlaps(theTwixShifted)) {
                          return Math.abs(wp.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                        } else {
                          return 0;
                        }
                      } else {
                        return 0;
                      }
                    }), function(accum, num) {
                      return accum + num;
                    }, 0),
                    tradeHoursDelta: (function() {
                      var hourAccum = 0;
                      // this day overlaps with the wp being given away
                      if ($scope.trade.work_period.range_twix.overlaps(theTwixShifted)) {
                        hourAccum -= Math.abs($scope.trade.work_period.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                      }
                      if (!$scope.trade.$isGiveaway() && $scope.trade.trade_work_period.range_twix.overlaps(theTwixShifted)) {
                        hourAccum += Math.abs($scope.trade.trade_work_period.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                      }
                      return hourAccum;
                    }())
                  };

                  ret.overlapsWithTradedWP = _.any(_.union($scope.initiatorWorkPeriods, concatData), function(wp) {
                    return (wp.id === $scope.trade.work_period.id || _.contains($scope.trade.work_period.related_work_period_ids, wp.id) ? ($scope.trade.work_period.range_twix.overlaps(theTwixShifted) &&
                        Math.abs($scope.trade.work_period.range_twix.intersection(theTwixShifted).length('minutes')) > 0 ) : false) ||
                        (!$scope.trade.$isGiveaway() &&
                            (wp.id === $scope.trade.trade_work_period.id || _.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id) ? ($scope.trade.trade_work_period.range_twix.overlaps(theTwixShifted) &&
                                Math.abs($scope.trade.trade_work_period.range_twix.intersection(theTwixShifted).length('minutes')) > 0) : false));
                  });
                  return ret;
                })
              };
              temp.hoursPerWeekWithoutTrade = _.reduce(temp.days, function(accum, day) {
                return accum + day.hoursWithoutTrade;
              }, 0);
              temp.tradeHoursDelta = _.reduce(temp.days, function(accum, day) {
                return accum + day.tradeHoursDelta;
              }, 0);

              return temp;
            });


            // Now that all of this hour data has been calculated...
            //  evaluate overtime
            var ovThresholdHours = parseInt($scope.me.memberships[0].organization.organization_config.overtime_threshold_hours);
            _.forEach($scope.initiatorWorkPeriodsByWeekAndDay, function(week) {
              console.log(week);
              if ((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta) > ovThresholdHours) {
                $scope.tradeAlerts.push({
                  employee: 'initiator',
                  weekTwix: week.days[0].dayStartDate.twix(moment(week.days[6].dayStartDate).add(1,'days')),
                  type: 'intoOvertime',
                  overtimeThresholdInHours: ovThresholdHours,
                  hoursPerWeekWithoutTrade: week.hoursPerWeekWithoutTrade,
                  hoursPerWeekWithTrade: (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta),
                  numHoursOver: week.hoursPerWeekWithoutTrade + week.tradeHoursDelta - ovThresholdHours
                });
                //are we over the threshold if we add just an hour?
              } else if (((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta + 1) > ovThresholdHours) &&  // jshint ignore:line
                  !((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta) > ovThresholdHours)) {              // jshint ignore:line
                $scope.tradeAlerts.push({
                  employee: 'initiator',
                  weekTwix: week.days[0].dayStartDate.twix(moment(week.days[6].dayStartDate).add(1,'days')),
                  type: 'closeToOvertime',
                  overtimeThresholdInHours: ovThresholdHours,
                  hoursPerWeekWithoutTrade: week.hoursPerWeekWithoutTrade,
                  hoursPerWeekWithTrade: (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta),
                  numHoursUnder: ovThresholdHours - (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta)
                });
              }
            });

            // Synthesize outcome of overtime checks
            //   Count up if there is any overtime at all, if there is anything close
            $scope.analysis.initiator.overtime = {};

            var intoOvertimeAlert = _.find($scope.tradeAlerts, function(alert) {
              return alert.employee === 'initiator' && alert.type === 'intoOvertime';
            });

            var closeToOvertimeAlert = _.find($scope.tradeAlerts, function(alert) {
              return alert.employee === 'initiator' && alert.type === 'closeToOvertime';
            });

            if (!_.isUndefined(intoOvertimeAlert)) {
              $scope.analysis.initiator.overtime.message = 'Adds ' + intoOvertimeAlert.numHoursOver.toFixed(1) + 'hrs of OT';
            } else if (!_.isUndefined(closeToOvertimeAlert)) {
              console.log('initiator close to overtime ');
              $scope.analysis.initiator.overtime.message = 'Within ' + closeToOvertimeAlert.numHoursUnder.toFixed(1) + 'hrs of OT';
            } else {
              $scope.analysis.initiator.overtime.message = 'No concern';
            }


            // check for overlap of trade.trade_work_period with trade.user's current schedule
            if (!$scope.trade.$isGiveaway()) {
              _.forEach($scope.initiatorWorkPeriods, function(wp) {
                //for the case that this has been approved, don't include any related_work_period_ids in the overlap calculations
                if (!_.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id) && wp.id !== $scope.trade.work_period.id) {
                  if (wp.range_twix.overlaps($scope.trade.trade_work_period.range_twix)) {
                    var intersection = wp.range_twix.intersection($scope.trade.trade_work_period.range_twix);
                    if (intersection.length('minutes') > 0) {
                      $scope.tradeAlerts.push({
                        employee: 'initiator',
                        type: 'overlaps',
                        intInMin: intersection.length('minutes'),
                        intersection: intersection,
                        workPeriod: wp
                      });
                    }
                  }
                }
              });
            }

            // Synthesize outcome of overlap checks
            //   Count up if there is any overlap at all, if there is anything close
            $scope.analysis.initiator.overlap = {};

            var overlapsAlert = _.find($scope.tradeAlerts, function(alert) {
              return alert.employee === 'initiator' && alert.type === 'overlaps';
            });

            if (!_.isUndefined(overlapsAlert)) {
              var timeToReport = overlapsAlert.intInMin.toFixed(1) + ' minutes';
              if (overlapsAlert.intInMin >= 60) {
                timeToReport = (overlapsAlert.intInMin / 60.0).toFixed(1) + ' hours';
              }
              $scope.analysis.initiator.overlap.message = 'Overlaps by ' + timeToReport;
            } else {
              $scope.analysis.initiator.overlap.message = 'No concern';
            }

          }, function() {
            console.log('had a problem loading initiatorData');
          });


      if ($scope.tradeHasReceiver) {
        var receiverData = {
          organization_id: $scope.trade.organization_id,
          start_time: $scope.affectedTimeWindow.fullSpan.start.toISOString(),
          end_time: $scope.affectedTimeWindow.fullSpan.end.toISOString()
        };

        if (!$scope.trade.$isGiveaway()) {
          // this isn't a giveaway and trade_work_period isn't null so this must be a targetted trade
          receiverData.user_id = $scope.trade.trade_work_period.user_id;
        } else {
          // trade is a giveaway and there is someone that accepted it!
          receiverData.user_id = $scope.trade.$acceptingUser().id;
        }

        WorkPeriods.getAll(receiverData).
            then(function(data) {
              $scope.receiverWorkPeriods = data;
              $scope.analysis.receiver = {};

              var concatData;
              if ($scope.trade.$isApproved()) {
                if (!$scope.trade.$isGiveaway()) {
                  // add back in the original shift up for trade when the trade has already been approved
                  concatData = [$scope.trade.trade_work_period];
                } else {
                  concatData = [];
                }
              } else {
                // adding work_period (what trade_user/trade.$receivingUser) will get when the trade is executed
                concatData = [$scope.trade.work_period];
              }

              $scope.receiverWorkPeriodsByWeekAndDay = _.map($scope.workPeriodDatesByWeek, function(weekOfDates, idWeek) {
                var temp = {
                  days: _.map(weekOfDates, function(dt, idDay) {
                    var theTwix = dt.twix(moment(dt).add(1, 'days'));
                    var theTwixShifted = $scope.workPeriodDatesByWeekShifted[idWeek][idDay].twix(moment($scope.workPeriodDatesByWeekShifted[idWeek][idDay]).add(1, 'days'));
                    var ret = {
                      dayStartDate: dt,
                      workPeriods: _.where(_.union($scope.receiverWorkPeriods, concatData), function(wp) {
                        //figure out what classes this wp should have
                        wp._cssClasses = {
                          red: !$scope.trade.$isGiveaway() && (wp.id === $scope.trade.trade_work_period.id || _.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id)),
                          green: wp.id === $scope.trade.work_period.id || _.contains($scope.trade.work_period.related_work_period_ids, wp.id),
                          continues: wp._intoNextDay
                        };

                        // where function to only get wp's where start_time is contained inside dt->dt+1d
                        return dt.twix(moment(dt).add(1, 'days')).contains(wp.start_time);
                      }),
                      hoursWithoutTrade: _.reduce(_.map(_.union($scope.receiverWorkPeriods, concatData), function(wp) {
                        // in the case of an approved trade, need to use concatData (trade.trade_work_period) as counted hours
                        //     AND reject wp.id in trade.work_period.related_work_period_ids

                        // in the case of an unapproved trade, need to reject concatData (trade.work_period.id)
                        if (($scope.trade.$isApproved() && !_.contains($scope.trade.work_period.related_work_period_ids, wp.id)) ||
                            (!$scope.trade.$isApproved() && wp.id !== trade.work_period.id)) {
                          if (wp.range_twix.overlaps(theTwixShifted)) {
                            return Math.abs(wp.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                          } else {
                            return 0;
                          }
                        } else {
                          return 0;
                        }

                      }), function(accum, num) {
                        return accum + num;
                      }, 0),
                      tradeHoursDelta: (function() {
                        var hourAccum = 0;
                        // this day overlaps with the wp being given away
                        if ($scope.trade.work_period.range_twix.overlaps(theTwixShifted)) {
                          hourAccum += Math.abs($scope.trade.work_period.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                        }
                        if (!$scope.trade.$isGiveaway() && $scope.trade.trade_work_period.range_twix.overlaps(theTwixShifted)) {
                          hourAccum -= Math.abs($scope.trade.trade_work_period.range_twix.intersection(theTwixShifted).length('minutes')) / 60.0;
                        }
                        return hourAccum;
                      }())
                    };
                    ret.overlapsWithTradedWP = _.any(_.union($scope.receiverWorkPeriods, concatData), function(wp) {
                      return (wp.id === $scope.trade.work_period.id || _.contains($scope.trade.work_period.related_work_period_ids, wp.id) ? ($scope.trade.work_period.range_twix.overlaps(theTwixShifted) &&
                          Math.abs($scope.trade.work_period.range_twix.intersection(theTwixShifted).length('minutes')) > 0 ) : false) ||
                          ( !$scope.trade.$isGiveaway() &&
                              (wp.id === $scope.trade.trade_work_period.id || _.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id) ? ($scope.trade.trade_work_period.range_twix.overlaps(theTwixShifted) &&
                                  Math.abs($scope.trade.trade_work_period.range_twix.intersection(theTwixShifted).length('minutes')) > 0) : false));
                    });
                    return ret;
                  })
                };

                temp.hoursPerWeekWithoutTrade = _.reduce(temp.days, function(accum, day) {
                  return accum + day.hoursWithoutTrade;
                }, 0);
                temp.tradeHoursDelta = _.reduce(temp.days, function(accum, day) {
                  return accum + day.tradeHoursDelta;
                }, 0);

                return temp;
              });


              // Now that all of this hour data has been calculated...
              //  evaluate overtime
              var ovThresholdHours = parseInt($scope.me.memberships[0].organization.organization_config.overtime_threshold_hours);
              _.forEach($scope.receiverWorkPeriodsByWeekAndDay, function(week) {

                if ((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta) > ovThresholdHours) {
                  $scope.tradeAlerts.push({
                    employee: 'receiver',
                    weekTwix: week.days[0].dayStartDate.twix(moment(week.days[6].dayStartDate).add(1,'days')),
                    type: 'intoOvertime',
                    overtimeThresholdInHours: ovThresholdHours,
                    hoursPerWeekWithoutTrade: week.hoursPerWeekWithoutTrade,
                    hoursPerWeekWithTrade: (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta),
                    numHoursOver: week.hoursPerWeekWithoutTrade + week.tradeHoursDelta - ovThresholdHours
                  });
                  //are we over the threshold if we add just an hour?
                } else if (((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta + 1) > ovThresholdHours) && // jshint ignore:line
                    !((week.hoursPerWeekWithoutTrade + week.tradeHoursDelta) > ovThresholdHours)) {   // jshint ignore:line
                  $scope.tradeAlerts.push({
                    employee: 'receiver',
                    weekTwix: week.days[0].dayStartDate.twix(moment(week.days[6].dayStartDate).add(1,'days')),
                    type: 'closeToOvertime',
                    overtimeThresholdInHours: ovThresholdHours,
                    hoursPerWeekWithoutTrade: week.hoursPerWeekWithoutTrade,
                    hoursPerWeekWithTrade: (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta),
                    numHoursUnder: ovThresholdHours - (week.hoursPerWeekWithoutTrade + week.tradeHoursDelta)
                  });
                }
              });

              // Synthesize outcome of overtime checks
              //   Count up if there is any overtime at all, if there is anything close
              $scope.analysis.receiver.overtime = {};

              var intoOvertimeAlert = _.find($scope.tradeAlerts, function(alert) {
                return alert.employee === 'receiver' && alert.type === 'intoOvertime';
              });

              var closeToOvertimeAlert = _.find($scope.tradeAlerts, function(alert) {
                return alert.employee === 'receiver' && alert.type === 'closeToOvertime';
              });

              if (!_.isUndefined(intoOvertimeAlert)) {
                $scope.analysis.receiver.overtime.message = 'Adds ' + intoOvertimeAlert.numHoursOver.toFixed(1) + 'hrs of OT';
              } else if (!_.isUndefined(closeToOvertimeAlert)) {
                console.log('receiver close to overtime ');
                if (closeToOvertimeAlert.numHoursUnder === 0) {
                  $scope.analysis.receiver.overtime.message = 'At the OT threshold';
                } else {
                  $scope.analysis.receiver.overtime.message = 'Within ' + closeToOvertimeAlert.numHoursUnder.toFixed(1) + 'hrs of OT';
                }
              } else {
                $scope.analysis.receiver.overtime.message = 'No concern';
              }

              // check for overlap of trade.trade_work_period with trade.user's current schedule
              _.forEach($scope.receiverWorkPeriods, function(wp) {
                //for the case that this has been approved, don't include any related_work_period_ids in the overlap calculations
                // also don't check for overlap between trade.work_period and trade.trade_work_period
                if (!_.contains($scope.trade.work_period.related_work_period_ids, wp.id) && ($scope.trade.$isGiveaway() ||  wp.id !== $scope.trade.trade_work_period.id)) {
                  if (wp.range_twix.overlaps($scope.trade.work_period.range_twix)) {
                    var intersection = wp.range_twix.intersection($scope.trade.work_period.range_twix);
                    if (intersection.length('minutes') > 0) {
                      $scope.tradeAlerts.push({
                        employee:'receiver',
                        type: 'overlaps',
                        intInMin: intersection.length('minutes'),
                        intersection: intersection,
                        workPeriod: wp
                      });
                    }
                  }
                }
              });

              // Synthesize outcome of overlap checks
              //   Count up if there is any overlap at all, if there is anything close
              $scope.analysis.receiver.overlap = {};

              var overlapsAlert = _.find($scope.tradeAlerts, function(alert) {
                return alert.employee === 'receiver' && alert.type === 'overlaps';
              });

              if (!_.isUndefined(overlapsAlert)) {
                var timeToReport = overlapsAlert.intInMin.toFixed(1) + ' minutes';
                if (overlapsAlert.intInMin >= 60) {
                  timeToReport = (overlapsAlert.intInMin / 60.0).toFixed(1) + ' hours';
                }
                $scope.analysis.receiver.overlap.message = 'Overlaps by ' + timeToReport;
              } else {
                $scope.analysis.receiver.overlap.message = 'No concern';
              }

            }, function() {
              console.log('had a problem loading initiatorData');
            });
      }

      // Let's get data on who is also working in these positions on these days
      $scope.analysis.alsoWorking = {
        workPeriod: undefined,
        tradeWorkPeriod: undefined
      };

      WorkPeriods.getAll({
        organization_id: $scope.trade.organization_id,
        position_id: $scope.trade.work_period.position.id,
        start_time: moment($scope.trade.work_period.start_time).subtract(12, 'hours').toISOString(),
        end_time: $scope.trade.work_period.end_time.toISOString()
      })
          .then(function(wps) {
            wps = _.where(wps, function(wp) {
              return wp.$isAssigned() && wp.$isPublished();
            });
            var newWp;
            // if the trade is approved we need to actually add the now OLD/inactive trade.work_period to the list
            if ($scope.trade.$isApproved()) {
              newWp = [WorkPeriods.initWithData(_.clone($scope.trade.work_period, true))];
              newWp[0].user = _.clone($scope.trade.user);
            } else {
              newWp = [WorkPeriods.initWithData(_.clone($scope.trade.work_period, true))];
              //if not a giveaway, assign this newWp as the trade_user
              //  otherwise, set is as undefined so that the UI will show "Waiting..."
              if ($scope.tradeHasReceiver) {
                newWp[0].user = _.clone($scope.trade.$receivingUser());
              } else {
                newWp[0].user = undefined;
              }
            }

            $scope.analysis.alsoWorking.workPeriods = _.sortBy(_.map(_.union(wps, newWp), function(wp) {
              wp._cssClasses = {
                subtracted_wp: !_.isUndefined(wp.user) && wp.user.id === $scope.trade.user.id && ($scope.trade.$isGiveaway() || wp.id === $scope.trade.work_period.id),
                additional_wp: (wp.user === undefined || (!_.isUndefined($scope.trade.$receivingUser()) && wp.user.id === $scope.trade.$receivingUser().id)) &&
                    wp.position.id === $scope.trade.work_period.position.id &&
                (wp.start_time.unix() === $scope.trade.work_period.start_time.unix() && wp.end_time.unix() === $scope.trade.work_period.end_time.unix())
              };

              return wp;
            }), '_startTimeUnix');
          });

      if (!$scope.trade.$isGiveaway()) {
        WorkPeriods.getAll({
          organization_id: $scope.trade.organization_id,
          position_id: $scope.trade.trade_work_period.position.id,
          start_time: moment($scope.trade.trade_work_period.start_time).subtract(12, 'hours').toISOString(),
          end_time: $scope.trade.trade_work_period.end_time.toISOString()
        })
            .then(function(wps) {
              wps = _.where(wps, function(wp) {
                return wp.$isAssigned() && wp.$isPublished();
              });
              var newWp;
              if ($scope.trade.$isApproved()) {
                newWp = [WorkPeriods.initWithData(_.clone($scope.trade.trade_work_period, true))];
                newWp[0].user = _.clone($scope.trade.$receivingUser());
              } else {
                newWp = [WorkPeriods.initWithData(_.clone($scope.trade.trade_work_period, true))];
                //if not a giveaway, assign this newWp as the trade_user
                //  otherwise, set is as undefined so that the UI will show "Waiting..."
                if ($scope.tradeHasReceiver) {
                  newWp[0].user = _.clone($scope.trade.user);
                } else {
                  newWp[0].user = undefined;
                }
              }
              $scope.analysis.alsoWorking.tradeWorkPeriods = _.sortBy(_.map(_.union(wps,newWp), function(wp) {
                wp._cssClasses = {
                  //To be the added "position" shift you workPeriod:
                  // 1) have the same user as the trade initiator (trade.user)
                  // 2) the workPeriod.id must be equal to the trade.trade_work_period.id (in the case where we're doing a clone before the trade has been approved
                  //      OR trade.trade_work_period.related_work_period_ids must contain the workPeriod.id (in the case that it HAS been approved)

                  // difference for subtracted is that you're trade.trade_user
                  additional_wp: wp.user.id === $scope.trade.user.id &&
                      (wp.id === $scope.trade.trade_work_period.id || _.contains($scope.trade.trade_work_period.related_work_period_ids, wp.id)),
                  subtracted_wp: wp.user.id === $scope.trade.$receivingUser().id &&
                      wp.id === $scope.trade.trade_work_period.id
                };
                return wp;
              }), '_startTimeUnix');
            });
      }

  });
